<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-bjznfxh">
        <div class="cover-text">
          <h4>边缘智能分析盒</h4>
          <p class="info">打造边缘感知中心，使设备成为感知信息处理中心，分布式设计降低了AI对云端的依赖，提升了稳定性和安全性。针对社区视频流数据庞大，难以高效实时处理问题，通过嵌入式神经网络处理器，直接对监控信息进行处理，实现对视频信息的实时分析。</p>
          <ol>
            <li>瑞芯微RK3399PRO处理器</li>
            <li>采用主频最高1.8GHz的臂双核A72大核、四核A53小核的架构</li>
            <li>集成Mali-T860图形处理器。高达3.0Tops算力的AI神经网络处理器</li>
          </ol>
        </div>
      </div>
    </div>
    <!-- 产品特点 -->
    <div class="product-features">
      <div class="common-title">
        <div class="common-title-content">
          产品特点
        </div>
      </div>
      <div class="product-feature-list">
        <div
          class="item item_fxh"
          v-for="(item, index) in features"
          :key="index"
        >
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/bjznfxh/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">超高精度识别算法</div>
          </div>
          <div class="feature feature-two">
            <div class="text">多AI厂商生态支持</div>
          </div>
          <div class="feature feature-three">
            <div class="text">量子密钥加密传输</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bjznfxh",
  data() {
    return {
      features: [
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/sjcs.png"),
          text: "数据传输高密性"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/znsb.png"),
          text: "智能设备可利旧"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/xmjs.png"),
          text: "项目建设低成本"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/yycj.png"),
          text: "应用场景可拓展"
        }
      ],
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ico_sjhj.png"),
          text: "数据汇聚"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ico_sbgl.png"),
          text: "设备管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ico_spfx.png"),
          text: "视频分析"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ico_sfxf.png"),
          text: "算法下发"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ico_hjwt.png"),
          text: "高能低耗"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ytkh.png"),
          text: "幼童看护"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/ljfl.png"),
          text: "垃圾分类"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/sdjc.png"),
          text: "摔倒监测"
        },
        {
          imgUrl: require("@/assets/images/productInfo/bjznfxh/hjjc.png"),
          text: "环境监测"
        }
      ]
    };
  }
};
</script>
